<template>
		<md-app md-mode="fixed" md-waterfall :class="{'vertical-layout': useVerticalLayout, 'nav-blocked': navBlocked}">
			<md-app-toolbar class="md-primary" md-elevation="0">
					<div>
						<md-button class="md-icon-button cheese-spin" @click="toggleNav" v-if="!navVisible">
							<md-icon v-if="useVerticalLayout">menu</md-icon>
							<img v-else src="data:image/svg+xml;utf8;base64,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" />
						</md-button>
						<md-tooltip md-direction="right" v-if="!navVisible">
							Expand Menu
						</md-tooltip>
					</div>
					<span class="md-title app-title">
						Caseen<span v-if="!useVerticalLayout"> - Virtual Patient Game</span>
					</span>
			</md-app-toolbar>
			<md-app-drawer :md-active.sync="navVisible" md-persistent="mini" v-show="!(navBlocked || (useVerticalLayout && !navVisible))">
				<md-toolbar class="md-transparent" md-elevation="0">
					<span>Navigation</span>
					<div class="md-toolbar-section-end">
						<md-button class="md-icon-button md-dense" @click="toggleNav">
							<md-icon>keyboard_arrow_left</md-icon>
						</md-button>
					</div>
				</md-toolbar>
				<hr v-if="navVisible" style="margin: 0px;">
				<md-list>
					<md-list-item v-for="entry in navEntries" :key="entry.nav_text"  v-if="entry.nav_url && !entry.hideEntry">
							<router-link :to="entry.nav_url" style="text-decoration: none">
								<div class="nav-entry" @click="navVisible = false">
									<span>
										<md-icon v-if="entry.nav_icon" scale=1.2>{{entry.nav_icon}}</md-icon>
										<md-tooltip v-show="!navVisible" md-direction="right">
											{{entry.nav_text}}
										</md-tooltip>
									</span>
									<span class="md-list-item-text nav-text">{{entry.nav_text}}</span>
								</div>
							</router-link>
					</md-list-item>
				</md-list>
				<span v-if="userStats.learnerScore">
					<hr style="margin: 8px 0;">
					<div>
						Learner:<br>
						<i class="fas fa-star"></i> {{userStats.learnerScore}}
					</div>
					<md-tooltip md-direction="right" style="height:auto; line-height: 160%; padding: 4px 6px">
						<div>Earn more points by completing</div>
						<div>and reviewing cases!</div>
					</md-tooltip>
				</span>
				<span v-if="userStats.authorScore">
					<hr style="margin: 8px 0;">
					<div>
						Author:<br>
						<i class="fas fa-star"></i> {{userStats.authorScore}}
					</div>
					<md-tooltip md-direction="right" style="height:auto; line-height: 160%; padding: 4px 6px">
						<div>Earn more points by authoring</div>
						<div>high quality cases!</div>
					</md-tooltip>
				</span>
				<hr style="margin: 8px 0;">
				<div style="margin: 20px 0 15px 0; width: 100%;" v-if="$store.state.jwtClaims.email && navVisible">
					Logged in as: 
					<br>
					{{$store.state.jwtClaims.email}}
				</div>
			</md-app-drawer>
			<md-app-content>
				<!-- Router component load-in point -->
				<router-view id="router-view" :useVerticalLayout="useVerticalLayout" v-on:toggleNavBlock="toggleNavBlock"></router-view>
				<hr>
				<Footer/>
			</md-app-content>
		</md-app>
</template>

<style src="vue-material/dist/vue-material.min.css"></style>
<style src="vue-material/dist/theme/default.css"></style>
<style src="quill/dist/quill.core.css"></style>
<style src="quill/dist/quill.snow.css"></style>

<style>
	.md-toolbar{
		height: 48px !important;
		min-height: 48px !important;
	}
	.md-app {
		height: 100%;
		border: 1px solid rgba(#000, .12);
	}
	.md-app-content {
		padding-bottom: 70px;
		position: relative;
	}
	.vertical-layout .md-app-content{
		padding-left: 0px;
		padding-right: 0px;
	}
	.vertical-layout .md-steppers{
		margin-left: 5px;
	}
	.vertical-layout #case-header{
		padding: 0px 10px;
	}
	.vertical-layout .md-stepper-content{
		padding-right: 20px !important;
	}
	#router-view{
		min-height: 80% !important;
		margin-bottom: 80px;
	}
	#router-view, .md-content, .md-app-scroller, 
	.md-app-drawer, .md-app-drawer, .md-app-drawer .md-list, 
	.md-stepper, .md-steppers-container, .md-steppers-wrapper,
	.md-table, .md-tabs-navigation{
		background-color: rgb(250, 250, 250) !important;
	}
	.app-title{
		margin: auto !important;
	}
	.vertical-layout .app-title{
		margin: 0 !important;
	}
	.cheese-spin{
			transition: 0.4s;
	}
	.cheese-spin:hover{
		transform: rotate(75deg);
	}
	.md-drawer {
		width: 230px !important;
		max-width: calc(100vw - 125px);
	}
	.md-drawer:not(.md-active) {
		top: -16px;
	}
	//Remove persistent side nav when on mobile 
	.vertical-layout .md-drawer.md-persistent-mini:not(.md-active){ 
		width: 0px !important; 
	}
	.vertical-layout .md-app-scroller.md-scrollbar, .nav-blocked .md-app-scroller.md-scrollbar { 
		padding-left: 0px!important;
	} 
	.nav-entry{
		display: inline-block;
		font-size: 150% !important;
		color: #2c3e50;
	}
	.nav-text{
		margin-left: 22px;
		display: inline;
	}
	.footer{
		/*position: absolute;
		bottom: 0;
		left: 0;*/
		width: 100%;
		margin-bottom: 20px;
	}
		::-webkit-scrollbar {
			width: 6px;
			height: 6px;
		}

		::-webkit-scrollbar-track {
			background-color: #ccc;
			border-radius: 5px;
		}

		::-webkit-scrollbar-thumb {
			background-color:#777;
			border-radius: 5px;
		}
		ul,ol{
			list-style-position: inside;
		}
		.ql-editor ul, .ql-editor ol {
			padding-left: 0.25em;
		}
		hr.soft{
			border: 0;
			height: 1px;
			background: #333;
			background-image: linear-gradient(to right, #ccc, #333, #ccc);
		}
		.md-tabs {
				border: 2px solid #aaa;
				border-radius: 5px;
		}
		.md-tabs-navigation {
				border-bottom: 1px solid #448aff;
		}
		.md-tabs-navigation .router-link-active.md-active{
			background-color: rgb(240, 240, 240);
		}
</style>

<script>
import APIRequests from "./APIRequests.js"
import Footer from "./Footer.vue"

export default {
	name: 'Overlap',
	components: {
		Footer
	},
	data: function() {
		return {
			navVisible: false,
			navBlocked: false,
			navEntries: [],
			useVerticalLayout: false,
			userStats: {}, 
		}
	},
	methods: {
		toggleNav: function(){
			if(!this.navBlocked){
				this.navVisible = !this.navVisible
			}
			else{
				this.navVisible = false
			}
		},
		toggleNavBlock: function(){
			this.navBlocked = !this.navBlocked
		},
		checkVerticalLayout: function (){
			this.useVerticalLayout = window.innerWidth < 800
		},
		getUserStats() {
			if (!this.$store.state.jwtClaims.pid || !this.$store.state.jwtClaims.acceptedTOS) return
			var api_url = this.$store.state.api_url + "/api/users/userStats/" + this.$store.state.jwtClaims.pid
			return APIRequests.getJSONData(
					api_url, 
					this.$store.state.jwtToken
			).then((data) => {
					this.userStats = data
			})
		},
	},
	mounted: function(){
		this.$nextTick(() => {
			this.checkVerticalLayout()
			this.getUserStats()
			window.addEventListener("resize", this.checkVerticalLayout);
			this.navEntries = [
				{nav_text: "Home", nav_icon: "home", nav_url: "/"},
				{nav_text: "Case List", nav_icon: "speaker_notes", nav_url: "/cases"},
				{nav_text: "Editor", nav_icon: "edit", nav_url: "/editor"},
				{nav_text: "Classrooms", nav_icon: "class", nav_url: "/classrooms/"},
				/*{nav_text: "Playlists", nav_icon: "play_circle_filled", nav_url: "/playlists/"},*/
				{nav_text: "Leaderboard", nav_icon: "format_list_numbered", nav_url: "/scoreboard", hideEntry: !this.$store.state.jwtClaims.isAdmin},
				{nav_text: "Settings", nav_icon: "settings_applications", nav_url: "/settings/", hideEntry: !this.$store.state.jwtToken},
				{nav_text: "Admin", nav_icon: "dvr", nav_url: "/admin/", hideEntry: !this.$store.state.jwtClaims.isAdmin},
				{nav_text: "Logout", nav_icon: "exit_to_app", nav_url: "/logout", hideEntry: !this.$store.state.jwtToken}
			]
		})
	}
}
</script>
